import React from 'react';
import ContentBox from "../contentBox/contentBox";
import "./latestContent.css"
const  LatestContent = (props) => {
    const list  = props.list
    return (
            <div className={"latest-content"}>
                <div className={"latest-content-section"}>
                    {
                        list && list.map((item)=>{
                            return(
                                    <ContentBox
                                        route={"blog"}
                                        title={item.title}
                                        image={item.image}
                                        description={item.description}
                                        slug={item.slug}
                                        id={item._id}
                                    />
                            )
                        })
                    }
                </div>
            </div>
    );
};

export default  LatestContent;
